<template>
    <label class="radio" :disabled="disabled" @click.stop>
        <input class="radio__input" type="radio" :name="name" :checked="checked" :disabled="disabled" @change="toggleCheck">
        <span class="radio__custom"></span>
        <span v-if="title" class="radio__text">{{ title }}</span>
    </label>
</template>

<script>
export default {
  name: 'app-radio',
  props: {
    checked: Boolean,
    title: String,
    disabled: Boolean,
    name: {
      type: String,
      default: ''
    }
  },
  methods: {
    toggleCheck () {
      this.$emit('toggle-check')
    }
  }
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/css/system/_vars';
    @import '../../../assets/css/system/_mixins';

    .radio {
        display: flex;
        flex-flow: row nowrap;
        width: max-content;
        cursor: pointer;
        user-select: none;

        &__input {
            display: none;

            &:checked+.radio__custom {
                &:after {
                    display: block;
                }
            }
        }

        &__custom {
            position: relative;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;

            &:before {
                content: '';
                @include size(20px);
                border: 1px solid $color_second-light;
                border-radius: 50%;
                transition: .3s;
            }

            &:after {
                content: '';
                display: none;
                position: absolute;
                top: 50%;
                left: 50%;
                @include size(14px);
                border-radius: 50%;
                background-color: $color_second-light;
                border: 1px solid $color_second-light;
                box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
                animation: fadeIn .3s linear;
                transform: translate(-50%, -50%);
            }
        }

        &__text {
            position: relative;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            margin-left: 15px;
        }

        &:hover {
            .radio__custom:before {
                border: 1px solid $color_second-dark;
            }
        }

        &[disabled] {
            pointer-events: none;

            .radio__custom {
                color: $color_deactive;

                &:before {
                    border: 1px solid $color_deactive;
                    background-color: $color_deactive-bg;
                }
            }

            .radio__text {
                color: $color_deactive;
            }
        }
    }
</style>
